import clsx from "clsx";
import Button from "../common/Button";
import Loader from "../common/Loader";

const AdminTable = ({
  columns = [],
  data = [],
  loading = false,
  emptyMessage = "No records found.",
  rowKey = "id",
  actions = null,
  className = "",
}) => {
  const getRowKey = (row, index) => {
    if (typeof rowKey === "function") return rowKey(row, index);
    return row?.[rowKey] ?? index;
  };

  return (
    <div className={clsx("table-scroll", className)}>
      {loading ? (
        <Loader text="Loading data..." />
      ) : data.length === 0 ? (
        <div className="empty-state">
          <p className="text-base font-medium text-[#3b2f2f]">{emptyMessage}</p>
        </div>
      ) : (
        <table className="table-base">
          <thead>
            <tr>
              {columns.map((column) => (
                <th
                  key={column.key}
                  className={clsx(column.headerClassName)}
                >
                  {column.label}
                </th>
              ))}

              {actions ? <th>Actions</th> : null}
            </tr>
          </thead>

          <tbody>
            {data.map((row, index) => (
              <tr key={getRowKey(row, index)}>
                {columns.map((column) => (
                  <td key={column.key} className={clsx(column.cellClassName)}>
                    {typeof column.render === "function"
                      ? column.render(row, index)
                      : row?.[column.key] ?? "—"}
                  </td>
                ))}

                {actions ? (
                  <td>
                    <div className="flex flex-wrap gap-2">
                      {actions(row).map((action, actionIndex) => (
                        <Button
                          key={`${getRowKey(row, index)}-${actionIndex}`}
                          type="button"
                          size="sm"
                          variant={action.variant || "secondary"}
                          onClick={action.onClick}
                          disabled={action.disabled}
                        >
                          {action.label}
                        </Button>
                      ))}
                    </div>
                  </td>
                ) : null}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminTable;